import Vue from "vue";
import VueRouter from "vue-router";
import RouterPrefetch from "vue-router-prefetch";
import App from "./App";
// TIP: change to import router from "./router/starterRouter"; to start with a clean layout
import router from "./router/index";

import BlackDashboard from "./plugins/blackDashboard";
import i18n from "./i18n";
import "./registerServiceWorker";

import VueSocketIOExt from 'vue-socket.io-extended';
import  io from 'socket.io-client';

import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

import ToggleButton from "vue-js-toggle-button";

import { Datetime } from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'


Vue.use(BlackDashboard);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(ToggleButton);
Vue.use(Loading);
Vue.component('loading', Loading)
Vue.component('datetime', Datetime);

const socket = io('https://api.terraaqua.rs', { autoConnect: false });


Vue.use(
  VueSocketIOExt, socket
);


/* eslint-disable no-new */
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
